import {useCallback, useRef} from 'react';
import {PATHS} from 'routes/constants';
import {
  DiscardLastPhotoModal,
  DiscardLastPhotoModalRef,
} from 'components/common/DiscardLastPhotoModal';

export function useDiscardLastPhotoBack(redirectTo: string = PATHS.verification.main) {
  const ref = useRef<DiscardLastPhotoModalRef>(null);

  const onBack = useCallback(() => ref.current?.open(redirectTo), [redirectTo]);

  const modal = <DiscardLastPhotoModal ref={ref} />;

  return {onBack, modal};
}
